import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "summary-section" }
const _hoisted_2 = { class: "summary-hero" }
const _hoisted_3 = { class: "hero-left" }
const _hoisted_4 = { class: "hero-kpis" }
const _hoisted_5 = { class: "widgets-grid" }
const _hoisted_6 = { class: "summary-hero" }
const _hoisted_7 = { class: "hero-left" }
const _hoisted_8 = { class: "hero-title-row" }
const _hoisted_9 = { class: "hero-title" }
const _hoisted_10 = { class: "hero-kpis" }
const _hoisted_11 = { class: "kpi" }
const _hoisted_12 = { class: "kpi-value" }
const _hoisted_13 = { class: "kpi" }
const _hoisted_14 = { class: "kpi-value" }
const _hoisted_15 = { class: "kpi" }
const _hoisted_16 = { class: "kpi-value" }
const _hoisted_17 = { class: "kpi" }
const _hoisted_18 = { class: "kpi-value" }
const _hoisted_19 = { class: "hero-donut" }
const _hoisted_20 = {
  class: "donut-svg",
  viewBox: "0 0 120 120"
}
const _hoisted_21 = ["stroke", "stroke-dasharray"]
const _hoisted_22 = {
  x: "60",
  y: "55",
  "text-anchor": "middle",
  class: "donut-pct",
  "font-size": "22",
  "font-weight": "700",
  fill: "var(--ink,#201f1e)"
}
const _hoisted_23 = { class: "widgets-grid" }
const _hoisted_24 = {
  key: 0,
  class: "widget-empty"
}
const _hoisted_25 = {
  key: 1,
  class: "widget-list"
}
const _hoisted_26 = { class: "task-item-bar" }
const _hoisted_27 = { class: "task-item-info" }
const _hoisted_28 = { class: "task-item-name" }
const _hoisted_29 = { class: "task-item-meta" }
const _hoisted_30 = {
  key: 2,
  class: "widget-more"
}
const _hoisted_31 = { class: "widget-head" }
const _hoisted_32 = {
  key: 0,
  class: "widget-badge-count"
}
const _hoisted_33 = {
  key: 0,
  class: "widget-empty widget-empty--ok"
}
const _hoisted_34 = {
  key: 1,
  class: "widget-list"
}
const _hoisted_35 = { class: "task-item-name" }
const _hoisted_36 = { class: "late-date" }
const _hoisted_37 = {
  key: 2,
  class: "widget-more"
}
const _hoisted_38 = {
  key: 0,
  class: "widget-empty"
}
const _hoisted_39 = {
  key: 1,
  class: "widget-list"
}
const _hoisted_40 = { class: "task-item-name" }
const _hoisted_41 = {
  key: 2,
  class: "widget-more"
}
const _hoisted_42 = {
  key: 0,
  class: "widget-empty"
}
const _hoisted_43 = {
  key: 1,
  class: "widget-list"
}
const _hoisted_44 = { class: "task-item-name" }
const _hoisted_45 = { class: "task-item-meta" }
const _hoisted_46 = {
  key: 2,
  class: "widget-more"
}
const _hoisted_47 = {
  key: 0,
  class: "widget-empty"
}
const _hoisted_48 = {
  key: 1,
  class: "widget-list"
}
const _hoisted_49 = { class: "task-item-name" }
const _hoisted_50 = { class: "task-item-meta" }
const _hoisted_51 = {
  key: 2,
  class: "widget-more"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SkeletonBlock = _resolveComponent("SkeletonBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_component_SkeletonBlock, {
                width: "220px",
                height: "24px"
              }),
              _createElementVNode("div", _hoisted_4, [
                (_openBlock(), _createElementBlock(_Fragment, null, _renderList(4, (i) => {
                  return _createVNode(_component_SkeletonBlock, {
                    key: i,
                    width: "60px",
                    height: "34px"
                  })
                }), 64))
              ])
            ]),
            _createVNode(_component_SkeletonBlock, {
              width: "120px",
              height: "120px",
              radius: "50%"
            })
          ]),
          _createElementVNode("div", _hoisted_5, [
            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(5, (i) => {
              return _createElementVNode("div", {
                key: i,
                class: "widget widget--skeleton"
              }, [
                _createVNode(_component_SkeletonBlock, {
                  width: "60%",
                  height: "14px"
                }),
                _createVNode(_component_SkeletonBlock, {
                  width: "100%",
                  height: "12px"
                }),
                _createVNode(_component_SkeletonBlock, {
                  width: "80%",
                  height: "12px"
                })
              ])
            }), 64))
          ])
        ], 64))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _createElementVNode("h2", _hoisted_9, _toDisplayString(_ctx.projectName), 1),
                _createElementVNode("span", {
                  class: _normalizeClass(['status-pill', _ctx.delayedTasks.length > 0 ? 'status-late' : 'status-ok'])
                }, _toDisplayString(_ctx.delayedTasks.length > 0 ? `${_ctx.delayedTasks.length} atrasada${_ctx.delayedTasks.length > 1 ? 's' : ''}` : 'Em dia'), 3)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _createElementVNode("div", _hoisted_11, [
                  _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.ganttRows.length), 1),
                  _cache[5] || (_cache[5] = _createElementVNode("span", { class: "kpi-label" }, "Tarefas", -1))
                ]),
                _cache[9] || (_cache[9] = _createElementVNode("div", { class: "kpi-divider" }, null, -1)),
                _createElementVNode("div", _hoisted_13, [
                  _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.todayTasks.length), 1),
                  _cache[6] || (_cache[6] = _createElementVNode("span", { class: "kpi-label" }, "Hoje", -1))
                ]),
                _cache[10] || (_cache[10] = _createElementVNode("div", { class: "kpi-divider" }, null, -1)),
                _createElementVNode("div", _hoisted_15, [
                  _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.openTickets.length), 1),
                  _cache[7] || (_cache[7] = _createElementVNode("span", { class: "kpi-label" }, "Chamados", -1))
                ]),
                _cache[11] || (_cache[11] = _createElementVNode("div", { class: "kpi-divider" }, null, -1)),
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("span", _hoisted_18, _toDisplayString(_ctx.projectReports.length), 1),
                  _cache[8] || (_cache[8] = _createElementVNode("span", { class: "kpi-label" }, "Relatórios", -1))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_19, [
              (_openBlock(), _createElementBlock("svg", _hoisted_20, [
                _cache[12] || (_cache[12] = _createElementVNode("circle", {
                  cx: "60",
                  cy: "60",
                  r: "48",
                  fill: "none",
                  stroke: "rgba(0,0,0,0.07)",
                  "stroke-width": "12"
                }, null, -1)),
                _createElementVNode("circle", {
                  cx: "60",
                  cy: "60",
                  r: "48",
                  fill: "none",
                  stroke: _ctx.progress >= 100 ? '#16a34a' : _ctx.progress > 60 ? 'var(--accent,#0f4c81)' : _ctx.progress > 30 ? '#f59e0b' : '#ef4444',
                  "stroke-width": "12",
                  "stroke-linecap": "round",
                  "stroke-dasharray": `${(_ctx.progress * 301.59 / 100).toFixed(2)} 301.59`,
                  transform: "rotate(-90 60 60)",
                  class: "donut-arc"
                }, null, 8, _hoisted_21),
                _createElementVNode("text", _hoisted_22, _toDisplayString(_ctx.progress) + "%", 1),
                _cache[13] || (_cache[13] = _createElementVNode("text", {
                  x: "60",
                  y: "72",
                  "text-anchor": "middle",
                  "font-size": "10",
                  fill: "var(--ink-muted,#605e5c)"
                }, "progresso", -1))
              ]))
            ])
          ]),
          _createElementVNode("div", _hoisted_23, [
            _createElementVNode("div", {
              class: "widget",
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('navigate', 'gantt'))),
              role: "button",
              tabindex: "0"
            }, [
              _cache[14] || (_cache[14] = _createStaticVNode("<div class=\"widget-head\" data-v-1fbe02fc><div class=\"widget-icon widget-icon--blue\" data-v-1fbe02fc><svg width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-1fbe02fc><rect x=\"3\" y=\"4\" width=\"18\" height=\"18\" rx=\"2\" data-v-1fbe02fc></rect><line x1=\"16\" y1=\"2\" x2=\"16\" y2=\"6\" data-v-1fbe02fc></line><line x1=\"8\" y1=\"2\" x2=\"8\" y2=\"6\" data-v-1fbe02fc></line><line x1=\"3\" y1=\"10\" x2=\"21\" y2=\"10\" data-v-1fbe02fc></line></svg></div><span class=\"widget-title\" data-v-1fbe02fc>Tarefas de hoje</span><span class=\"widget-link\" data-v-1fbe02fc>Ver planejamento →</span></div>", 1)),
              (_ctx.todayTasks.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, "Nenhuma tarefa para hoje."))
                : (_openBlock(), _createElementBlock("ul", _hoisted_25, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.todayTasks.slice(0, 4), (task) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: task.id,
                        class: "widget-task-item"
                      }, [
                        _createElementVNode("div", _hoisted_26, [
                          _createElementVNode("div", {
                            class: "task-item-fill",
                            style: _normalizeStyle({ width: _ctx.taskPct(task) + '%' })
                          }, null, 4)
                        ]),
                        _createElementVNode("div", _hoisted_27, [
                          _createElementVNode("span", _hoisted_28, _toDisplayString(task.title), 1),
                          _createElementVNode("span", _hoisted_29, _toDisplayString(_ctx.resolveUser(task.assigneeUsername)) + " · " + _toDisplayString(_ctx.taskPct(task)) + "%", 1)
                        ])
                      ]))
                    }), 128))
                  ])),
              (_ctx.todayTasks.length > 4)
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, "+" + _toDisplayString(_ctx.todayTasks.length - 4) + " tarefa(s)", 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: _normalizeClass(["widget", { 'widget--warn': _ctx.delayedTasks.length > 0 }]),
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('navigate', 'gantt'))),
              role: "button",
              tabindex: "0"
            }, [
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", {
                  class: _normalizeClass(["widget-icon", _ctx.delayedTasks.length > 0 ? 'widget-icon--red' : 'widget-icon--green'])
                }, [...(_cache[15] || (_cache[15] = [
                  _createElementVNode("svg", {
                    width: "14",
                    height: "14",
                    viewBox: "0 0 24 24",
                    fill: "none",
                    stroke: "currentColor",
                    "stroke-width": "2.5",
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round"
                  }, [
                    _createElementVNode("circle", {
                      cx: "12",
                      cy: "12",
                      r: "10"
                    }),
                    _createElementVNode("line", {
                      x1: "12",
                      y1: "8",
                      x2: "12",
                      y2: "12"
                    }),
                    _createElementVNode("line", {
                      x1: "12",
                      y1: "16",
                      x2: "12.01",
                      y2: "16"
                    })
                  ], -1)
                ]))], 2),
                _cache[16] || (_cache[16] = _createElementVNode("span", { class: "widget-title" }, "Tarefas atrasadas", -1)),
                (_ctx.delayedTasks.length > 0)
                  ? (_openBlock(), _createElementBlock("span", _hoisted_32, _toDisplayString(_ctx.delayedTasks.length), 1))
                  : _createCommentVNode("", true)
              ]),
              (_ctx.delayedTasks.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_33, "Todas em dia ✓"))
                : (_openBlock(), _createElementBlock("ul", _hoisted_34, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.delayedTasks.slice(0, 3), (task) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: task.id,
                        class: "widget-item late-item"
                      }, [
                        _createElementVNode("span", _hoisted_35, _toDisplayString(task.title), 1),
                        _createElementVNode("span", _hoisted_36, "venceu " + _toDisplayString(_ctx.formatDate(task.plannedEnd)), 1)
                      ]))
                    }), 128))
                  ])),
              (_ctx.delayedTasks.length > 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_37, "+" + _toDisplayString(_ctx.delayedTasks.length - 3) + " tarefa(s)", 1))
                : _createCommentVNode("", true)
            ], 2),
            _createElementVNode("div", {
              class: "widget",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('navigate', 'tickets'))),
              role: "button",
              tabindex: "0"
            }, [
              _cache[17] || (_cache[17] = _createStaticVNode("<div class=\"widget-head\" data-v-1fbe02fc><div class=\"widget-icon widget-icon--orange\" data-v-1fbe02fc><svg width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-1fbe02fc><path d=\"M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z\" data-v-1fbe02fc></path></svg></div><span class=\"widget-title\" data-v-1fbe02fc>Chamados abertos</span><span class=\"widget-link\" data-v-1fbe02fc>Ver todos →</span></div>", 1)),
              (_ctx.openTickets.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_38, "Nenhum chamado aberto."))
                : (_openBlock(), _createElementBlock("ul", _hoisted_39, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.openTickets.slice(0, 3), (t) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: t.id,
                        class: "widget-item"
                      }, [
                        _createElementVNode("span", _hoisted_40, _toDisplayString(t.title), 1),
                        _createElementVNode("span", {
                          class: _normalizeClass(['ticket-prio', `ticket-prio--${t.priority}`])
                        }, _toDisplayString(t.priority), 3)
                      ]))
                    }), 128))
                  ])),
              (_ctx.openTickets.length > 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_41, "+" + _toDisplayString(_ctx.openTickets.length - 3) + " chamado(s)", 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: "widget",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$emit('navigate', 'reports'))),
              role: "button",
              tabindex: "0"
            }, [
              _cache[18] || (_cache[18] = _createStaticVNode("<div class=\"widget-head\" data-v-1fbe02fc><div class=\"widget-icon widget-icon--teal\" data-v-1fbe02fc><svg width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-1fbe02fc><path d=\"M14 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V8z\" data-v-1fbe02fc></path><polyline points=\"14 2 14 8 20 8\" data-v-1fbe02fc></polyline><line x1=\"16\" y1=\"13\" x2=\"8\" y2=\"13\" data-v-1fbe02fc></line><line x1=\"16\" y1=\"17\" x2=\"8\" y2=\"17\" data-v-1fbe02fc></line><polyline points=\"10 9 9 9 8 9\" data-v-1fbe02fc></polyline></svg></div><span class=\"widget-title\" data-v-1fbe02fc>Relatórios</span><span class=\"widget-link\" data-v-1fbe02fc>Ver todos →</span></div>", 1)),
              (_ctx.projectReports.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_42, "Nenhum relatório."))
                : (_openBlock(), _createElementBlock("ul", _hoisted_43, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectReports.slice(0, 3), (r) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: r.id,
                        class: "widget-item"
                      }, [
                        _createElementVNode("span", _hoisted_44, _toDisplayString(r.title), 1),
                        _createElementVNode("span", _hoisted_45, _toDisplayString(_ctx.formatDate(r.reportDate)), 1)
                      ]))
                    }), 128))
                  ])),
              (_ctx.projectReports.length > 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_46, "+" + _toDisplayString(_ctx.projectReports.length - 3) + " relatório(s)", 1))
                : _createCommentVNode("", true)
            ]),
            _createElementVNode("div", {
              class: "widget",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('navigate', 'warehouse'))),
              role: "button",
              tabindex: "0"
            }, [
              _cache[19] || (_cache[19] = _createStaticVNode("<div class=\"widget-head\" data-v-1fbe02fc><div class=\"widget-icon widget-icon--purple\" data-v-1fbe02fc><svg width=\"14\" height=\"14\" viewBox=\"0 0 24 24\" fill=\"none\" stroke=\"currentColor\" stroke-width=\"2.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\" data-v-1fbe02fc><rect x=\"2\" y=\"7\" width=\"20\" height=\"14\" rx=\"2\" data-v-1fbe02fc></rect><path d=\"M16 7V5a2 2 0 00-2-2h-4a2 2 0 00-2 2v2\" data-v-1fbe02fc></path></svg></div><span class=\"widget-title\" data-v-1fbe02fc>Almoxarifado</span><span class=\"widget-link\" data-v-1fbe02fc>Ver reservas →</span></div>", 1)),
              (_ctx.projectReservations.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_47, "Sem reservas ativas."))
                : (_openBlock(), _createElementBlock("ul", _hoisted_48, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.projectReservations.slice(0, 3), (res) => {
                      return (_openBlock(), _createElementBlock("li", {
                        key: res.id,
                        class: "widget-item"
                      }, [
                        _createElementVNode("span", _hoisted_49, _toDisplayString(_ctx.resolveItem(res.itemId)), 1),
                        _createElementVNode("span", _hoisted_50, "×" + _toDisplayString(res.quantity), 1)
                      ]))
                    }), 128))
                  ])),
              (_ctx.projectReservations.length > 3)
                ? (_openBlock(), _createElementBlock("div", _hoisted_51, "+" + _toDisplayString(_ctx.projectReservations.length - 3) + " reserva(s)", 1))
                : _createCommentVNode("", true)
            ])
          ])
        ], 64))
  ]))
}